import {ChangeDetectionStrategy, Component, computed, inject, input, output} from '@angular/core';
import {DesignBlockData} from "../../../base-design-block-modal/types/base-design-block.types";
import {defaultDesignBlockData} from "../../../base-design-block-modal/configs/default-design-block-data";
import { AttachFileParams, EntityFileType } from "../../../../../../../../core/types/file.types";
import {RecordUpdateRequestParams} from "../../../../../../../../core/types/records-table.types";
import {
  BaseDesignBlockPathStateService
} from "../../../base-design-block-modal/services/base-design-block-path-state.service";
import {ListingFilesModalService} from "../../services/listing-files-modal.service";
import {ListingFilesStateService} from "../../services/listing-files-state.service";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";
import {FormsModule} from "@angular/forms";
import {
  FileUploadCardComponent
} from "../../../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";

@Component({
  selector: 'div[app-lf-bottom-modal]',
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    CdkTextareaAutosize,
    FormsModule,
    FileUploadCardComponent
  ],
  templateUrl: './lf-bottom-modal.component.html',
  styleUrl: './lf-bottom-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LfBottomModalComponent {
  designBlockData = input<DesignBlockData>(defaultDesignBlockData);
  listingEntityFileType = input<EntityFileType>('LISTING');
  isEditModeActive = input<boolean>(false);
  isActiveUploadFile = input<boolean>(false);
  updateComment = output<DesignBlockData>();
  attachFile = output<AttachFileParams>();

  private baseDesignBlockPathStateService: BaseDesignBlockPathStateService = inject(BaseDesignBlockPathStateService);
  private listingFilesModalService: ListingFilesModalService = inject(ListingFilesModalService);
  private listingFilesStateService: ListingFilesStateService = inject(ListingFilesStateService);

  public remainingFileSlots = computed(() => this.listingFilesStateService.getRemainingFileSlots());

  public async handleUpdateComment(): Promise<void> {
    const params: RecordUpdateRequestParams = {
      path: this.baseDesignBlockPathStateService.pathState(),
      recordId: this.designBlockData().id,
      fieldName: 'comment',
      value: this.designBlockData().comment
    };

    const updateData = await this.listingFilesModalService.updatedRecordField<DesignBlockData>(params).catch(() => this.designBlockData());
    this.updateComment.emit(updateData);
  }

  public handleAttachFile(attachFileParams: AttachFileParams): void {
    this.attachFile.emit(attachFileParams);
  }
}
